/**
 * @generated SignedSource<<cd71fbd54cd58f935f6f7bfe5dc62bbf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type BackfillClientContactsInput = {
  dryRun?: boolean | null;
  afterCompanyId?: number | null;
  limit?: number | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type backfillClientContactsMutation$variables = {
  input: BackfillClientContactsInput;
};
export type backfillClientContactsMutation$data = {
  readonly backfillClientContacts: {
    readonly companiesProcessed: number | null;
    readonly companiesFailed: number | null;
    readonly contactsCreated: number | null;
    readonly companiesWithContactsToCreate: number | null;
    readonly dryRun: boolean | null;
    readonly lastCompanyId: number | null;
    readonly companiesRemaining: number | null;
    readonly companies: ReadonlyArray<{
      readonly companyId: number | null;
      readonly companyName: string | null;
      readonly tier: string | null;
      readonly contactsToCreate: number | null;
      readonly contactsSkipped: number | null;
      readonly contacts: ReadonlyArray<{
        readonly personId: number | null;
        readonly clientId: number | null;
        readonly clientName: string | null;
        readonly firstName: string | null;
        readonly lastName: string | null;
        readonly email: string | null;
        readonly personCreatedAt: string | null;
        readonly reason: string | null;
        readonly willCreate: boolean | null;
      } | null> | null;
    } | null> | null;
    readonly failures: ReadonlyArray<{
      readonly companyId: number | null;
      readonly companyName: string | null;
      readonly tier: string | null;
      readonly error: string | null;
    } | null> | null;
  } | null;
};
export type backfillClientContactsMutation = {
  variables: backfillClientContactsMutation$variables;
  response: backfillClientContactsMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "companyId",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "companyName",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tier",
  "storageKey": null
},
v4 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "BackfillClientContactsPayload",
    "kind": "LinkedField",
    "name": "backfillClientContacts",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "companiesProcessed",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "companiesFailed",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "contactsCreated",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "companiesWithContactsToCreate",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "dryRun",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lastCompanyId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "companiesRemaining",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "MissionControlClientContactsBackfillCompany",
        "kind": "LinkedField",
        "name": "companies",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "contactsToCreate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "contactsSkipped",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MissionControlClientContactsBackfillContact",
            "kind": "LinkedField",
            "name": "contacts",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "personId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "clientId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "clientName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "firstName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lastName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "email",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "personCreatedAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "reason",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "willCreate",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "MissionControlClientContactsBackfillFailure",
        "kind": "LinkedField",
        "name": "failures",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "error",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "backfillClientContactsMutation",
    "selections": (v4/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "backfillClientContactsMutation",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "8c29375dfeb5e6f173f65d50cd571977",
    "id": null,
    "metadata": {},
    "name": "backfillClientContactsMutation",
    "operationKind": "mutation",
    "text": "mutation backfillClientContactsMutation(\n  $input: BackfillClientContactsInput!\n) {\n  backfillClientContacts(input: $input) {\n    companiesProcessed\n    companiesFailed\n    contactsCreated\n    companiesWithContactsToCreate\n    dryRun\n    lastCompanyId\n    companiesRemaining\n    companies {\n      companyId\n      companyName\n      tier\n      contactsToCreate\n      contactsSkipped\n      contacts {\n        personId\n        clientId\n        clientName\n        firstName\n        lastName\n        email\n        personCreatedAt\n        reason\n        willCreate\n      }\n    }\n    failures {\n      companyId\n      companyName\n      tier\n      error\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7e5c04c57f4dccefcab4b6a3b25079ae";

export default node;
